// import React, { useState, useEffect, useRef } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import { API_URL } from "../constants";
// import { PostServiceCaller, GetServiceCaller } from "../services/serviceCaller";
// import { useNavigate, Link } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { setAuthentication } from "../store/reducers/auth";
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";
// import { FaSpinner } from "react-icons/fa";
// import moment from "moment";
// import { toast } from "react-toastify";
// import Select from "react-select";
// import styled from "styled-components";
// import NonBillableemployee from "../modules/ROM/RomReport/NonBillableemployee";
// import profileBanner from "../assets/ProfileBanner.png";
// import * as yup from "yup";
// import AttendanceCalendar from "./AttendanceCalander";
// import EmployeeSearchDropdown from "./EmployeeSearchDropdown";
// import ResetPasswordModal from "./ResetPasswordModel";
// import NestAILogo from "../assets/Nest_AI_Logo.png";
// import NestAILogoMobile from "../assets/AI_Logo_mobile_Device.png";
// import TravelDesk from "../assets/Travel_Desk.png";

// const Navbar = ({ heading, heading_icon, position, isOpen, setIsOpen }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   let user = JSON.parse(localStorage.getItem("user")) || {};
//   const dropdownNotiRef = useRef(null);
//   const notifcationData = useSelector(
//     ({ layoutReducer }) => layoutReducer?.filterSlice?.dashboardApiData
//   );
//   console.log("notifcationData", notifcationData);

//   const [attendanceCalenderOpen, setAttendanceCalenderOpen] = useState(false);
//   const [NotificationOpen, setNotificationOpen] = useState(false);
//   const [notifyData, setNotifyData] = useState(notifcationData);
//   console.log("notifyData", notifyData);

//   useEffect(() => {
//     setNotifyData(notifcationData);
//   }, [notifcationData]);
//   const [searchOpen, setSearchOpen] = useState(false);
//   const [employeeOption, setEmployeeOption] = useState([]);
//   const [currentDay] = useState(new Date().getDate());
//   const [isLoading, setIsLoading] = useState(false);
//   const dropdownRef = useRef(null);
//   const searchdropdownRef = useRef(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setAttendanceCalenderOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         searchdropdownRef.current &&
//         !searchdropdownRef.current.contains(event.target)
//       ) {
//         setSearchOpen(false);
//       }
//     };
//     if (searchOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [searchOpen]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         // Close the dropdown
//         setNotificationOpen(false); // assuming your state is NotificationOpen
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (
//       heading == "Dashboard" ||
//       heading == "Employee Profile | Nice Software Solutions Pvt. Ltd."
//     ) {
//       document.title = "NEST";
//     } else {
//       document.title = heading;
//     }
//   }, [heading]);

//   const logout = async () => {
//     try {
//       const response = await GetServiceCaller(`${API_URL}logout`);
//       if (response?.status === 200) {
//         localStorage.removeItem("token");
//         localStorage.removeItem("user");
//         localStorage.setItem("logout", 1);

//         dispatch(setAuthentication(undefined));
//         // toast.success("Logout Successfully!");

//         navigate("/login");
//       }
//     } catch (error) {
//       console.error("Logout Error:", error);
//       toast.error("Something went wrong during logout");
//     }
//   };

//   const toggleDropdown = () => {
//     setAttendanceCalenderOpen(!attendanceCalenderOpen);
//   };

//   const toggleNotiDropdown = (e) => {
//     e.stopPropagation();
//     setNotificationOpen(!NotificationOpen);
//   };
//   const searchToggleDropdown = () => {
//     setSearchOpen(!searchOpen);
//   };
//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       minHeight: "30px",
//       height: "30px",
//       width: "150px",
//       fontSize: "14px",
//     }),
//     valueContainer: (provided) => ({
//       ...provided,
//       padding: "0 8px",
//     }),
//     indicatorsContainer: (provided) => ({
//       ...provided,
//       height: "30px",
//     }),
//   };

//   const handleProfilePage = () => {
//     if (user.ID) {
//       navigate(`/employee-profile/${user.DefaultContactID}`);
//     } else {
//       console.error("User ID not found");
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         dropdownNotiRef.current &&
//         !dropdownNotiRef.current.contains(event.target)
//       ) {
//         setNotificationOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   const toggle = (e) => {
//     e?.stopPropagation();
//     e?.preventDefault();
//     setIsOpen((prev) => {
//       return !prev;
//     });
//   };
//   return (
//     <div>
//       <nav className="navbar navbar-expand-lg bg-white">
//         <div className="container-fluid nav-mainHeading">
//           {/** Navbar Heading Section  */}
//           <div className="d-flex align-items-center">
//             <div className="mobile-menu-icon me-3">
//               <i
//                 className="bi bi-list d-block d-sm-none"
//                 onClick={(e) => toggle()}
//                 style={{ fontSize: "1.5rem", cursor: "pointer" }}
//               ></i>
//             </div>

//             <div className="">
//               <h6 className="nav-heading m-0">
//                 <strong>{heading}</strong>
//               </h6>
//             </div>
//           </div>

//           <div className="d-flex gap-2">
//             {/* Comment code for Temporary */}
//             <div className="profile-area d-flex align-items-center">
//               <div>
//                 <a
//                   href={`https://nest.nicesoftwaresolutions.ai?token=${localStorage.getItem("token")}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src={NestAILogo}
//                     alt="ai-Img"
//                     className="d-none d-md-block"
//                     style={{
//                       width: "80px",
//                       height: "30px",
//                       objectFit: "contain",
//                       cursor: "pointer",
//                     }}
//                   />
//                 </a>
//                 <a
//                   href={`https://nest.nicesoftwaresolutions.ai?token=${localStorage.getItem("token")}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src={NestAILogoMobile}
//                     alt="ai-Img"
//                     className="d-block d-md-none"
//                     style={{
//                       width: "50px",
//                       height: "20px",
//                       objectFit: "contain",
//                       cursor: "pointer",
//                     }}
//                   />
//                 </a>
//               </div>
//             </div>

//             <div className="profile-area d-flex align-items-center">
//               <div className="profile-area d-flex align-items-center">
//                 <div className="d-none d-lg-block">
//                   <div
//                     style={{
//                       width: "1px",
//                       height: "15px",
//                       borderLeft: "2px dotted #BAC4CD",
//                       margin: "8px auto",
//                       marginRight: "10px",
//                     }}
//                   ></div>
//                 </div>
//               </div>
//             </div>
//             {/** Navbar Search Term Section  */}
//             <div className="profile-area d-flex align-items-center">
//               <div className="profile-area d-flex align-items-center">
//                 <div className="dropstart" ref={searchdropdownRef}>
//                   <div className="d-flex" style={{ cursor: "pointer" }}>
//                     <div className="d-none d-lg-block"></div>
//                     <div className="nav-icons">
//                       <OverlayTrigger
//                         placement="bottom"
//                         overlay={
//                           <Tooltip id="kpi-tooltip">Travel Desk</Tooltip>
//                         }
//                       >
//                         <a
//                           href="https://apps.powerapps.com/play/e/default-842e4e0e-1c63-4147-b5bc-2b8baed2f998/a/0dd2f767-d9cd-4a0c-8a87-38678de04b5c?tenantId=842e4e0e-1c63-4147-b5bc-2b8baed2f998&hint=f743993a-ee68-4413-aefd-c74b575f0fb5&sourcetime=1756115911204"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <img
//                             src={TravelDesk}
//                             alt="Travel Desk"
//                             style={{
//                               width: "30px",
//                               height: "30px",
//                               marginLeft: "1px",
//                               marginTop: "2px",
//                               filter: "brightness(0) invert(1)",
//                             }}
//                           />
//                         </a>
//                       </OverlayTrigger>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="profile-area d-flex align-items-center">
//               <div className="profile-area d-flex align-items-center">
//                 <div className="dropstart" ref={searchdropdownRef}>
//                   <div
//                     className="d-flex"
//                     onClick={searchToggleDropdown}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <div className="d-none d-lg-block"></div>
//                     <div className="nav-icons">
//                       <OverlayTrigger
//                         placement="bottom"
//                       overlay={
//                         !searchOpen ? (
//                           <Tooltip id="kpi-tooltip">Search Employee</Tooltip>
//                         ) : (
//                           <></>
//                         )
//                       }
//                       >
//                         <i className="bi bi-search"></i>
//                       </OverlayTrigger>
//                     </div>
//                   </div>

//                   {searchOpen && <EmployeeSearchDropdown />}
//                 </div>
//               </div>
//             </div>
//             {/** Mark Attendance Section  */}
//             <div className="profile-area d-flex align-items-center">
//               <div className="dropstart" ref={dropdownRef}>
//                 <div
//                   className="d-flex"
//                   onClick={toggleDropdown}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <div className="nav-icons">
//                     <OverlayTrigger
//                       placement="bottom"
//                       overlay={
//                         !attendanceCalenderOpen ? (
//                           <Tooltip id="kpi-tooltip">Mark Attendance</Tooltip>
//                         ) : (
//                           <></>
//                         )
//                       }
//                     >
//                       <i className="bi bi-calendar-check"></i>
//                     </OverlayTrigger>
//                   </div>
//                 </div>
//                 {attendanceCalenderOpen && (
//                   <ul
//                     className="employee-profile dropdown-menu dropdown-menu-end p-2 m-0 show mt-2"
//                     style={{
//                       left: window.innerWidth < 768 ? "50%" : "40%",
//                       transform:
//                         window.innerWidth < 768
//                           ? "translateX(-85%)"
//                           : "translateX(-65%)",
//                       top: "100%",
//                       minWidth: "220px",
//                       maxWidth: "320px",
//                       position: "absolute",
//                       zIndex: 1050,
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                       borderRadius: "8px",
//                       ...(window.innerWidth < 768 && { width: "85vw" }), // Optional: Adjust width on mobile
//                     }}
//                   >
//                     <AttendanceCalendar
//                       attendanceCalenderOpen={attendanceCalenderOpen}
//                       setAttendanceCalenderOpen={setAttendanceCalenderOpen}
//                     />
//                   </ul>
//                 )}
//               </div>
//             </div>
//             {/** Notification Section  */}
//             <div className="profile-area d-flex align-items-center">
//               <div className="profile-area d-flex align-items-center">
//                 <div className="dropstart" ref={dropdownNotiRef}>
//                   <div
//                     // className="dropdown-toggle d-flex"
//                     className="d-flex"
//                     onClick={toggleNotiDropdown}
//                     style={{ cursor: "pointer" }}
//                     aria-expanded={NotificationOpen}
//                   >
//                     <div className="nav-icons">
//                       <OverlayTrigger
//                         placement="bottom"
//                       overlay={
//                         !NotificationOpen ? (
//                           <Tooltip id="kpi-tooltip">Notification</Tooltip>
//                         ) : (
//                           <></>
//                         )
//                       }
//                       >
//                         <i className="bi bi-bell"></i>
//                       </OverlayTrigger>
//                       {notifyData?.length > 0 && (
//                         <div className="notiNo">&bull;</div>
//                       )}
//                     </div>
//                   </div>
//                   {NotificationOpen && (
//                     <ul
//                       style={{
//                         left: "0px",
//                         transform:
//                           window.innerWidth < 768 ? "none" : "translateX(-40%)",
//                         top: "100%",
//                         minWidth: "220px",
//                         maxWidth: "320px",
//                         position: "absolute",
//                         zIndex: 1050,
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                         borderRadius: "8px",
//                         // For mobile, you might want to add these:
//                         ...(window.innerWidth < 768 && {
//                           left: "10%",
//                           transform: "translateX(-90%)",
//                           width: "40vw",
//                         }),
//                       }}
//                       className="employee-profile dropdown-menu dropdown-menu-end show mt-2"
//                     >
//                       <div style={{ padding: "0" }}>
//                         {/* Notifications List */}
//                         <div style={{ maxHeight: "320px", overflowY: "auto" }}>
//                           {notifyData?.length > 0 ? (
//                             notifyData?.map((item, index) => {
//                               // Use DOM parser to extract elements
//                               let href = "#";
//                               let iconClass = "";
//                               let text = "";

//                               try {
//                                 const parser = new DOMParser();
//                                 const doc = parser.parseFromString(
//                                   item.Msg,
//                                   "text/html"
//                                 );
//                                 const anchor = doc.querySelector("a");

//                                 // Get href if it exists
//                                 href = anchor?.getAttribute("href") || "#";

//                                 // Get icon element and its classes
//                                 const icon = anchor?.querySelector("i");
//                                 iconClass = icon?.getAttribute("class") || "";

//                                 // Get text content
//                                 text = anchor?.textContent.trim() || "";
//                               } catch (e) {
//                                 console.error("DOM parsing error:", e);
//                                 // Fallback to simple text extraction if parsing fails
//                                 text = item.Msg.replace(/<[^>]*>/g, "").trim();
//                               }

//                               return (
//                                 <div
//                                   key={index}
//                                   style={{
//                                     borderBottom:
//                                       index < notifyData.length - 1
//                                         ? "1px solid #f9fafb"
//                                         : "none",
//                                   }}
//                                 >
//                                   <a
//                                     href={href}
//                                     style={{
//                                       display: "flex",
//                                       alignItems: "flex-start",
//                                       padding: "6px 8px",
//                                       textDecoration: "none",
//                                       color: "#374151",
//                                       transition: "background-color 0.2s ease",
//                                       cursor: "pointer",
//                                     }}
//                                     target="_blank"
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       window.location.href = href;
//                                     }}
//                                   >
//                                     <div
//                                       style={{
//                                         marginRight: "12px",
//                                         marginTop: "2px",
//                                         flexShrink: 0,
//                                         backgroundColor: "#DFEBFF",
//                                         borderRadius: "50%",
//                                         height: "20px",
//                                         width: "20px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         marginTop: "-3px",
//                                       }}
//                                     >
//                                       <i
//                                         className={iconClass}
//                                         style={{
//                                           color: "#141468",
//                                           fontSize: "12px",
//                                         }}
//                                       ></i>
//                                     </div>

//                                     {/* Content */}
//                                     <div
//                                       style={{
//                                         flex: 1,
//                                         minWidth: 0,
//                                       }}
//                                     >
//                                       <div
//                                         style={{
//                                           fontSize: "10px",
//                                           lineHeight: "1.4",
//                                           color: "#374151",
//                                           wordWrap: "break-word",
//                                         }}
//                                       >
//                                         {text}
//                                       </div>
//                                     </div>
//                                   </a>
//                                 </div>
//                               );
//                             })
//                           ) : (
//                             <div
//                               style={{
//                                 padding: "10px 8px",
//                                 textAlign: "center",
//                                 color: "#9ca3af",
//                               }}
//                             >
//                               <i
//                                 className="fa fa-bell-slash"
//                                 style={{
//                                   fontSize: "24px",
//                                   marginBottom: "8px",
//                                   display: "block",
//                                 }}
//                               ></i>
//                               <p
//                                 style={{
//                                   fontSize: "14px",
//                                   margin: "0",
//                                 }}
//                               >
//                                 No notifications available
//                               </p>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </ul>
//                   )}
//                 </div>
//               </div>
//             </div>
//             {/** User Profile Card Section  */}
//             <div className="profile-area d-flex align-items-center">
//               <div className="profile-area d-flex align-items-center ms-0 ms-md-3">
//                 <div className="dropdown">
//                   <div
//                     className="d-flex"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     <img
//                       className="avatar me-2"
//                       src={user?.ProfileImagePath}
//                       style={{ cursor: "pointer" }}
//                       alt="profile"
//                     />
//                     <div className="d-none d-lg-block">
//                       <h5
//                         className="profile-name"
//                         style={{ cursor: "pointer" }}
//                       >
//                         <div className="mb-0" style={{ fontSize: "12px" }}>
//                           <strong>{user.Name || ""}</strong>
//                         </div>
//                         <div style={{ fontSize: "10px" }}>
//                           {user.Designation || ""}
//                         </div>
//                       </h5>
//                     </div>
//                   </div>
//                   <ul
//                     className="employee-profile dropdown-menu dropdown-menu-end p-0 mt-2"
//                     aria-labelledby="dropdownMenuButton1"
//                     style={{
//                       border: "none",
//                       minWidth: "220px",
//                       maxWidth: "320px",
//                       zIndex: 1050,
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                       borderRadius: "8px",
//                       overflow: "visible",
//                     }}
//                   >
//                     <div>
//                       <div className="profile-card">
//                         <div className="upper">
//                           <img src={profileBanner} className="img-fluid" />
//                         </div>

//                         <div className="user text-center">
//                           <div className="profile">
//                             <img
//                               className="avatar"
//                               src={user.ProfileImagePath || ""}
//                               alt="ProfileImg"
//                             />
//                           </div>
//                         </div>

//                         <div
//                           className="text-center"
//                           style={{ marginTop: "50px" }}
//                         >
//                           <h5 className="mb-0">
//                             <b>{user?.Name || ""}</b>
//                           </h5>
//                           <span className="text-muted d-block">
//                             {user.Designation || ""}
//                           </span>
//                           <span
//                             className="text-muted d-block mb-3"
//                             style={{ color: "#27568B", fontWeight: "600" }}
//                           >
//                             {user.Code || ""}
//                           </span>
//                           <div className="d-flex gap-1 justify-content-center align-item-center">
//                             <OverlayTrigger
//                               placement="top"
//                               overlay={
//                                 <Tooltip id="tooltip-bottom">Profile</Tooltip>
//                               }
//                             >
//                               <div className="stats">
//                                 <button
//                                   className="custom-btn"
//                                   onClick={handleProfilePage}
//                                 >
//                                   <i className="bi bi-person-circle"></i>{" "}
//                                 </button>
//                               </div>
//                             </OverlayTrigger>

//                             <div className="stats">
//                               <button
//                                 className="custom-btn"
//                                 // onClick={() => navigate("/change-password")}
//                                 onClick={() => setShowModal(true)}
//                               >
//                                 <i className="bi bi-shield-lock"></i> Reset
//                                 Password
//                               </button>
//                             </div>

//                             <OverlayTrigger
//                               placement="top"
//                               overlay={
//                                 <Tooltip id="tooltip-bottom">Logout</Tooltip>
//                               }
//                             >
//                               <div className="stats">
//                                 <button
//                                   className="custom-btn"
//                                   onClick={(e) => logout(e)}
//                                 >
//                                   <i className="bi bi-box-arrow-right"></i>
//                                 </button>
//                               </div>
//                             </OverlayTrigger>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </nav>
//       <ResetPasswordModal showModal={showModal} setShowModal={setShowModal} />
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useEffect, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { API_URL } from "../constants";
import { PostServiceCaller, GetServiceCaller } from "../services/serviceCaller";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuthentication } from "../store/reducers/auth";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import styled from "styled-components";
import NonBillableemployee from "../modules/ROM/RomReport/NonBillableemployee";
import profileBanner from "../assets/ProfileBanner.png";
import * as yup from "yup";
import AttendanceCalendar from "./AttendanceCalander";
import EmployeeSearchDropdown from "./EmployeeSearchDropdown";
import ResetPasswordModal from "./ResetPasswordModel";
import NestAILogo from "../assets/Nest_AI_Logo.png";
import NestAILogoMobile from "../assets/AI_Logo_mobile_Device.png";
import TravelDesk from "../assets/Travel_Desk.png";

const Navbar = ({ heading, heading_icon, position, isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let user = JSON.parse(localStorage.getItem("user")) || {};
  const dropdownNotiRef = useRef(null);
  const notifcationData = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.dashboardApiData
  );

  const [attendanceCalenderOpen, setAttendanceCalenderOpen] = useState(false);
  const [NotificationOpen, setNotificationOpen] = useState(false);
  const [notifyData, setNotifyData] = useState(notifcationData);

  useEffect(() => {
    setNotifyData(notifcationData);
  }, [notifcationData]);

  const [searchOpen, setSearchOpen] = useState(false);
  const [employeeOption, setEmployeeOption] = useState([]);
  const [currentDay] = useState(new Date().getDate());
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);
  const searchdropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);

  // --- Track Window Width ---
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // --- Dynamic Style Helper ---
  const getDropdownStyle = () => {
    if (windowWidth < 768) {
      // MOBILE: Fixed Center
      return {
        position: "fixed",
        top: "80px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "90vw",
        maxWidth: "350px",
        maxHeight: "80vh",
        overflowY: "auto",
        zIndex: 1055,
        backgroundColor: "white",
        boxShadow: "0 0 15px rgba(0,0,0,0.2)",
        borderRadius: "8px",
        padding: "10px",
      };
    } else {
      // DESKTOP: Anchored to Right Edge
      return {
        position: "absolute",
        top: "100%",
        right: "0",
        left: "auto",
        minWidth: "300px",
        maxWidth: "350px",
        zIndex: 1050,
        backgroundColor: "white",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        borderRadius: "8px",
        marginTop: "10px",
      };
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAttendanceCalenderOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchdropdownRef.current &&
        !searchdropdownRef.current.contains(event.target)
      ) {
        setSearchOpen(false);
      }
    };
    if (searchOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownNotiRef.current &&
        !dropdownNotiRef.current.contains(event.target)
      ) {
        setNotificationOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (
      heading == "Dashboard" ||
      heading == "Employee Profile | Nice Software Solutions Pvt. Ltd."
    ) {
      document.title = "NEST";
    } else {
      document.title = heading;
    }
  }, [heading]);

  const logout = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}logout`);
      if (response?.status === 200) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.setItem("logout", 1);
        dispatch(setAuthentication(undefined));
        navigate("/login");
      }
    } catch (error) {
      console.error("Logout Error:", error);
      toast.error("Something went wrong during logout");
    }
  };

  const toggleDropdown = () => {
    setAttendanceCalenderOpen(!attendanceCalenderOpen);
  };

  const toggleNotiDropdown = (e) => {
    e.stopPropagation();
    setNotificationOpen(!NotificationOpen);
  };
  const searchToggleDropdown = () => {
    setSearchOpen(!searchOpen);
  };

  const handleProfilePage = () => {
    if (user.ID) {
      navigate(`/employee-profile/${user.DefaultContactID}`);
    } else {
      console.error("User ID not found");
    }
  };

  const toggle = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    setIsOpen((prev) => {
      return !prev;
    });
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-white">
        {/* ADDED flex-nowrap to prevent wrapping on mobile */}
        <div className="container-fluid nav-mainHeading flex-nowrap">
          
          {/** Navbar Heading Section */}
          <div className="d-flex align-items-center">
            <div className="mobile-menu-icon me-2 me-sm-3">
              <i
                className="bi bi-list d-block d-sm-none"
                onClick={(e) => toggle()}
                style={{ fontSize: "1.5rem", cursor: "pointer" }}
              ></i>
            </div>

            <div className="">
              {/* MODIFIED: Hide text on XS screens (d-none d-sm-block) to save space */}
              <h6 className="nav-heading m-0 d-none d-sm-block">
                <strong>{heading}</strong>
              </h6>
            </div>
          </div>

          {/* MODIFIED: Reduced gap on mobile (gap-1) */}
          <div className="d-flex gap-1 gap-sm-2 align-items-center">
            
            {/* Logo Section */}
            <div className="profile-area d-flex align-items-center">
              <div>
                <a
                  href={`https://nest.nicesoftwaresolutions.ai?token=${localStorage.getItem(
                    "token"
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={NestAILogo}
                    alt="ai-Img"
                    className="d-none d-md-block"
                    style={{
                      width: "80px",
                      height: "30px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                  />
                </a>
                {/* Mobile Logo - slightly smaller width to save space if needed */}
                <a
                  href={`https://nest.nicesoftwaresolutions.ai?token=${localStorage.getItem(
                    "token"
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={NestAILogoMobile}
                    alt="ai-Img"
                    className="d-block d-md-none"
                    style={{
                      width: "40px", // Reduced from 50px for better fit
                      height: "20px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                  />
                </a>
              </div>
            </div>

            {/* Separator - Hidden on very small mobile to save space */}
            <div className="profile-area d-flex align-items-center d-none d-sm-block">
              <div className="profile-area d-flex align-items-center">
                <div className="d-none d-lg-block">
                  <div
                    style={{
                      width: "1px",
                      height: "15px",
                      borderLeft: "2px dotted #BAC4CD",
                      margin: "8px auto",
                      marginRight: "10px",
                    }}
                  ></div>
                </div>
              </div>
            </div>

            {/** Travel Desk Icon Section */}
            <div className="profile-area d-flex align-items-center">
              <div className="profile-area d-flex align-items-center">
                <div className="dropdown">
                  <div className="d-flex" style={{ cursor: "pointer" }}>
                    <div className="d-none d-lg-block"></div>
                    <div className="nav-icons">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="kpi-tooltip">Travel Desk</Tooltip>}
                      >
                        <a
                          href="https://apps.powerapps.com/play/e/default-842e4e0e-1c63-4147-b5bc-2b8baed2f998/a/0dd2f767-d9cd-4a0c-8a87-38678de04b5c?tenantId=842e4e0e-1c63-4147-b5bc-2b8baed2f998&hint=f743993a-ee68-4413-aefd-c74b575f0fb5&sourcetime=1756115911204"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={TravelDesk}
                            alt="Travel Desk"
                            style={{
                              width: "30px",
                              height: "30px",
                              marginLeft: "1px",
                              marginTop: "2px",
                              filter: "brightness(0) invert(1)",
                            }}
                          />
                        </a>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Search Section */}
            <div className="profile-area d-flex align-items-center">
              <div className="profile-area d-flex align-items-center">
                <div
                  className="dropdown"
                  ref={searchdropdownRef}
                  style={{ position: "relative" }}
                >
                  <div
                    className="d-flex"
                    onClick={searchToggleDropdown}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-none d-lg-block"></div>
                    <div className="nav-icons">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          !searchOpen ? (
                            <Tooltip id="kpi-tooltip">Search Employee</Tooltip>
                          ) : (
                            <></>
                          )
                        }
                      >
                        <i className="bi bi-search"></i>
                      </OverlayTrigger>
                    </div>
                  </div>

                  {searchOpen && (
                    <div style={getDropdownStyle()}>
                      <style>
                        {`
                          .force-display .dropdown-menu {
                             display: block !important;
                             position: static !important;
                             width: 100% !important;
                             transform: none !important;
                             box-shadow: none !important;
                             border: none !important;
                          }
                        `}
                      </style>
                      <div className="force-display">
                        <EmployeeSearchDropdown />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Attendance Section */}
            <div className="profile-area d-flex align-items-center">
              <div
                className="dropdown"
                ref={dropdownRef}
                style={{ position: "relative" }}
              >
                <div
                  className="d-flex"
                  onClick={toggleDropdown}
                  style={{ cursor: "pointer" }}
                >
                  <div className="nav-icons">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        !attendanceCalenderOpen ? (
                          <Tooltip id="kpi-tooltip">Mark Attendance</Tooltip>
                        ) : (
                          <></>
                        )
                      }
                    >
                      <i className="bi bi-calendar-check"></i>
                    </OverlayTrigger>
                  </div>
                </div>
                {attendanceCalenderOpen && (
                  <ul
                    className="employee-profile dropdown-menu show mt-2"
                    style={getDropdownStyle()}
                  >
                    <AttendanceCalendar
                      attendanceCalenderOpen={attendanceCalenderOpen}
                      setAttendanceCalenderOpen={setAttendanceCalenderOpen}
                    />
                  </ul>
                )}
              </div>
            </div>

            {/* Notification Section */}
            <div className="profile-area d-flex align-items-center">
              <div className="profile-area d-flex align-items-center">
                <div
                  className="dropdown"
                  ref={dropdownNotiRef}
                  style={{ position: "relative" }}
                >
                  <div
                    className="d-flex"
                    onClick={toggleNotiDropdown}
                    style={{ cursor: "pointer" }}
                    aria-expanded={NotificationOpen}
                  >
                    <div className="nav-icons">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          !NotificationOpen ? (
                            <Tooltip id="kpi-tooltip">Notification</Tooltip>
                          ) : (
                            <></>
                          )
                        }
                      >
                        <i className="bi bi-bell"></i>
                      </OverlayTrigger>
                      {notifyData?.length > 0 && (
                        <div className="notiNo">&bull;</div>
                      )}
                    </div>
                  </div>
                  {NotificationOpen && (
                    <ul
                      style={getDropdownStyle()}
                      className="employee-profile dropdown-menu show mt-2"
                    >
                      <div style={{ padding: "0" }}>
                        <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                          {/* Notification list rendering logic remains same */}
                          {notifyData?.length > 0 ? (
                            notifyData?.map((item, index) => {
                              let href = "#";
                              let iconClass = "";
                              let text = "";
                              try {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(
                                  item.Msg,
                                  "text/html"
                                );
                                const anchor = doc.querySelector("a");
                                href = anchor?.getAttribute("href") || "#";
                                const icon = anchor?.querySelector("i");
                                iconClass = icon?.getAttribute("class") || "";
                                text = anchor?.textContent.trim() || "";
                              } catch (e) {
                                text = item.Msg.replace(/<[^>]*>/g, "").trim();
                              }
                              return (
                                <div
                                  key={index}
                                  style={{
                                    borderBottom:
                                      index < notifyData.length - 1
                                        ? "1px solid #f9fafb"
                                        : "none",
                                  }}
                                >
                                  <a
                                    href={href}
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      padding: "6px 8px",
                                      textDecoration: "none",
                                      color: "#374151",
                                      cursor: "pointer",
                                    }}
                                    target="_blank"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      window.location.href = href;
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginRight: "12px",
                                        marginTop: "2px",
                                        flexShrink: 0,
                                        backgroundColor: "#DFEBFF",
                                        borderRadius: "50%",
                                        height: "20px",
                                        width: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginTop: "-3px",
                                      }}
                                    >
                                      <i
                                        className={iconClass}
                                        style={{
                                          color: "#141468",
                                          fontSize: "12px",
                                        }}
                                      ></i>
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          lineHeight: "1.4",
                                          color: "#374151",
                                        }}
                                      >
                                        {text}
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                padding: "10px 8px",
                                textAlign: "center",
                                color: "#9ca3af",
                              }}
                            >
                              <i
                                className="fa fa-bell-slash"
                                style={{
                                  fontSize: "24px",
                                  marginBottom: "8px",
                                  display: "block",
                                }}
                              ></i>
                              <p style={{ fontSize: "14px", margin: "0" }}>
                                No notifications available
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {/** User Profile Card Section */}
            <div className="profile-area d-flex align-items-center">
              <div className="profile-area d-flex align-items-center ms-0 ms-md-3">
                <div className="dropdown">
                  <div
                    className="d-flex"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      className="avatar me-2"
                      src={user?.ProfileImagePath}
                      style={{ cursor: "pointer" }}
                      alt="profile"
                    />
                    <div className="d-none d-lg-block">
                      <h5 className="profile-name" style={{ cursor: "pointer" }}>
                        <div className="mb-0" style={{ fontSize: "12px" }}>
                          <strong>{user.Name || ""}</strong>
                        </div>
                        <div style={{ fontSize: "10px" }}>
                          {user.Designation || ""}
                        </div>
                      </h5>
                    </div>
                  </div>
                  <ul
                    className="employee-profile dropdown-menu dropdown-menu-end p-0 mt-2"
                    aria-labelledby="dropdownMenuButton1"
                    style={{
                      border: "none",
                      minWidth: "220px",
                      maxWidth: "320px",
                      zIndex: 1050,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      borderRadius: "8px",
                      overflow: "visible",
                    }}
                  >
                    {/* Profile Card Content */}
                    <div>
                      <div className="profile-card">
                        <div className="upper">
                          <img src={profileBanner} className="img-fluid" />
                        </div>
                        <div className="user text-center">
                          <div className="profile">
                            <img
                              className="avatar"
                              src={user.ProfileImagePath || ""}
                              alt="ProfileImg"
                            />
                          </div>
                        </div>
                        <div
                          className="text-center"
                          style={{ marginTop: "50px" }}
                        >
                          <h5 className="mb-0">
                            <b>{user?.Name || ""}</b>
                          </h5>
                          <span className="text-muted d-block">
                            {user.Designation || ""}
                          </span>
                          <span
                            className="text-muted d-block mb-3"
                            style={{ color: "#27568B", fontWeight: "600" }}
                          >
                            {user.Code || ""}
                          </span>
                          <div className="d-flex gap-1 justify-content-center align-item-center">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-bottom">Profile</Tooltip>
                              }
                            >
                              <div className="stats">
                                <button
                                  className="custom-btn"
                                  onClick={handleProfilePage}
                                >
                                  <i className="bi bi-person-circle"></i>{" "}
                                </button>
                              </div>
                            </OverlayTrigger>

                            <div className="stats">
                              <button
                                className="custom-btn"
                                onClick={() => setShowModal(true)}
                              >
                                <i className="bi bi-shield-lock"></i> Reset
                                Password
                              </button>
                            </div>

                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-bottom">Logout</Tooltip>
                              }
                            >
                              <div className="stats">
                                <button
                                  className="custom-btn"
                                  onClick={(e) => logout(e)}
                                >
                                  <i className="bi bi-box-arrow-right"></i>
                                </button>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <ResetPasswordModal showModal={showModal} setShowModal={setShowModal} />
    </div>
  );
};

export default Navbar;